import type { ClosureView, JobCloseOutcome } from '@nest-recruit/shared';

/** What switches parts of the closure screen on and off (#13, §L28). */
export interface ClosureModules {
  readonly isOffersOn: boolean;
  readonly isPoolsOn: boolean;
  readonly isOrganisationOn: boolean;
  readonly isRequisitionsOn: boolean;
}

/** The ledger sentence only while Organisation is on; the hiring request's only while Hire requests is. */
export function outcomeText(outcome: JobCloseOutcome, view: Pick<ClosureView, 'places'>, modules: ClosureModules): string {
  const unfilled = view.places.total - view.places.filled - view.places.waitingToJoin;
  const seats = modules.isOrganisationOn && unfilled > 0 ? ` The ${unfilled} unfilled ${unfilled === 1 ? 'place goes' : 'places go'} back to the position ledger as vacant.` : '';
  const people = 'Everyone still in the running becomes "Position no longer available" — never "Not selected" — and booked interviews are cancelled with an apology.';
  if (!modules.isRequisitionsOn) return `${people}${seats}`;
  return outcome === 'cancelled' ? `${people}${seats} The hiring request is cancelled.` : `${people}${seats} The hiring request is marked partly filled.`;
}

/** Cancelling can't be undone and emails everyone, so the confirm names how many. */
export function cancelQuestion(emailed: number): string {
  if (emailed === 0) return 'Cancel the job? Nobody is emailed.';
  return `Cancel the job and email ${emailed} ${emailed === 1 ? 'person' : 'people'}?`;
}
